import {useContext} from 'react';

import {WizardStepContext} from './WizardStepContext';

export function useWizardStepId() {
  return useContext(WizardStepContext);
}
